var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFillSpreadsheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 70,
    viewBox: "0 0 72 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "u4w85iqlxa",
    d: "M0 70h72V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.175 62.428 4.101-1.935 1.426 4.145s-.921.528-1.81.561c-.888.033-1.995-.308-1.995-.308l-1.722-2.463zM30.218 63.517l1.787-1.617 2.28 2.573s-3.059 1.859-4.067-.956",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "wu0vevpulb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u4w85iqlxa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#080717",
    mask: "url(#wu0vevpulb)",
    d: "M0 33.416h32.761v-1.671H.001z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)",
    d: "M29.784 32.58v36.949M2.549 32.58v36.949"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080717",
    mask: "url(#wu0vevpulb)",
    d: "M9.26 28.006h1.71V4.798H9.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.285 30.754V22.75a2.13 2.13 0 0 1 2.128-2.133h1.162",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080717",
    mask: "url(#wu0vevpulb)",
    d: "M4.39 32.58h5.33v-1.787H4.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.618 26.667a.197.197 0 0 0-.149-.069l-18.358.002-8.488 1.1a.198.198 0 0 0-.09.035l-3.79 2.728a.672.672 0 0 0-.271.667.672.672 0 0 0 .484.534c.535.15.974.177 1.39.081a.673.673 0 0 0 .53.885 3.056 3.056 0 0 0 2.476-.71h.002a.675.675 0 0 0 .67.747h.003a3.042 3.042 0 0 0 2.317-1.075l.806-.756 2.71.617a5.367 5.367 0 0 0 3.719-.5l.777-.415 7.813 2.655c.02.007.042.01.064.01h.006c.066-.001 6.573-.279 7.426-6.379a.196.196 0 0 0-.047-.157M55.057 64.852v4.751H43.39c-.98 0-1.142-1.77-.264-2.64l6.137-2.725s2.284 2.374 5.793.614",
    fill: "#FFF",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.057 64.978v3.393H43.39c-.98 0-1.142-1.012-.264-1.633l6.081-2.342s2.34 1.839 5.849.582",
    fill: "#6176F4",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.057 64.852v4.751H43.39c-.98 0-1.142-1.77-.264-2.64l6.137-2.725s2.284 2.374 5.793.614z",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.328 37.957H54.77c-.535 0-.892-.593-.798-1.324l1.517-11.758c.095-.731.605-1.324 1.14-1.324h14.557c.535 0 .892.593.798 1.324l-1.518 11.758c-.094.731-.604 1.324-1.14 1.324M66.442 49.384H42.318a.97.97 0 0 1-.97-.972V45.28a.97.97 0 0 1 .97-.972h24.124a.97.97 0 0 1 .968.972v3.133a.97.97 0 0 1-.968.972",
    fill: "#080717",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)",
    d: "M64.648 45.982v23.547M67.515 33.645 64.251 47.85M57.674 45.982v23.547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#wu0vevpulb)",
    d: "m41.99 47.405-10.495 13.46 3.11 3.563 12.273-9.765z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)",
    d: "m41.99 47.405-10.495 13.46 3.11 3.563 12.273-9.765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.959 25.63 39.613 46.081a3.355 3.355 0 0 0-.247 4.452l9.368 11.784 4.734-2.244-3.685-10.69 11.636-6.116a5.85 5.85 0 0 0 2.693-7.372L59.959 25.63z",
    fill: "#FFF",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.959 25.63 39.613 46.081a3.355 3.355 0 0 0-.247 4.452l9.368 11.784 4.734-2.244-3.685-10.69 11.636-6.116a5.85 5.85 0 0 0 2.693-7.372L59.959 25.63zM48.556 45.953l1.228 3.431",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.345 15.052s5.097-.965 8.772.285c8.64 2.938 9.862 17.758 9.862 17.758l-14.954 5.353c-1.934 1.642-2.807-5.658-2.932-8.197l-.748-15.2z",
    fill: "#484848",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.798 9.913s2.577-3.69 1.995-5.202c-.595-1.547-1.85-1.741-3.827-1.526-1.977.216-1.411-.944-3.99-.995-1.425-.028-2.555.535-2.726 1.397-.172.862-3.451 1.317-.241 4.168.944.839 6.737 3.848 8.79 2.158",
    fill: "#000",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.07 18.56-.012.012c1.289-1.31 1.686-3.013.888-3.803L41.691 9.57c-.798-.79-2.49-.368-3.78.942l.012-.01c-1.289 1.31-1.686 3.012-.888 3.802l5.255 5.198c.799.79 2.49.368 3.78-.942",
    fill: "#FFF",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.07 18.56-.012.012c1.289-1.31 1.686-3.013.888-3.803L41.691 9.57c-.798-.79-2.49-.368-3.78.942l.012-.01c-1.289 1.31-1.686 3.012-.888 3.802l5.255 5.198c.799.79 2.49.368 3.78-.942z",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#wu0vevpulb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.933 16.006c-4.246 2.29-4.102.06-4.521-3.08-.02-.14-.034-.281-.05-.421-.316 0-.795-.089-1.03-.205-.344-.172-.304-.345-.246-.496.326-.837.725-1.662 1.196-2.475l.006.055c.029-.461.072-.921.135-1.38.363-2.26 3.04-4.172 5.322-4.383 2.29-.214 4.228 1.665 4.281 4.185l-.012 5.364c-.02.792-.453 1.497-1.036 2.092",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.933 16.006c-4.246 2.29-4.102.06-4.521-3.08-.02-.14-.034-.281-.05-.421-.316 0-.795-.089-1.03-.205-.344-.172-.304-.345-.246-.496.326-.837.725-1.662 1.196-2.475l.006.055c.029-.461.072-.921.135-1.38.363-2.26 3.04-4.172 5.322-4.383 2.29-.214 4.228 1.665 4.281 4.185l-.012 5.364c-.02.792-.453 1.497-1.036 2.092",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.967 9.945c-.064.332-.309.563-.547.517-.238-.047-.378-.353-.314-.685.064-.331.309-.563.547-.516.238.046.379.352.314.684",
    fill: "#000",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.38 8.558a1.981 1.981 0 0 0-.282-.184 1.745 1.745 0 0 0-.97-.221M36.947 13.172c-.183.606-.644.804-1.368.804",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.621 15.422c-.02-.015-.071-.018-.061-.042 2.586-6.199-1.971-2.644-2.078-3.003-.562-1.877-.17-3.732-.234-4.76-.05-.778-.394-1.125-.74-1.278a5.856 5.856 0 0 1 4.782-2.458c3.244.007 5.104 2.336 5.096 5.59-.008 3.253-2.344 6.547-4.256 6.473-.57-.022-1.987-.37-2.509-.522",
    fill: "#000",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3 11.987a1.54 1.54 0 0 0 1.534 1.546 1.54 1.54 0 0 0 1.541-1.539 1.54 1.54 0 0 0-1.534-1.546 1.54 1.54 0 0 0-1.542 1.54",
    fill: "#FFF",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.053 5.965s-2.087.831-2.782.411c-.694-.42.773-3.205 2.163-3.271 1.39-.067 3.856.776 3.856.776l-3.237 2.084z",
    fill: "#000",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.261 11.354c-.515-.107-.879.049-1.076.577",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    mask: "url(#wu0vevpulb)",
    d: "M47.152 13.49 41.188 20l3.859 2.639 4.28-7.943z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.547 29.021-2.887 2.587a.478.478 0 0 0 .248.826 2.865 2.865 0 0 0 2.316-.664l1.744-1.509",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.407 29.534-1.755 2.158a.478.478 0 0 0 .374.777 2.866 2.866 0 0 0 2.183-1.022L25.43 30.3",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.089 30.618 2.816.641a5.167 5.167 0 0 0 3.581-.481l.852-.456 7.895 2.683",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.21 26.649-.777 8.13 5.941 1.788c2.48.746 5.07-.77 5.643-3.302l1.924-8.515-7.643 1.723-5.087.176z",
    fill: "#484848",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.433 34.78 5.941 1.788s4.777 1.364 6.7-1.715c1.924-3.08 2.582-10.03 2.582-10.03M19.115 31.18c-.697.473-1.296.519-2.107.293a.479.479 0 0 1-.15-.85l3.79-2.727 8.488-1.099h18.333",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.137 64.852v4.751H22.471c-.98 0-1.142-1.77-.263-2.64l7.72-3.518s.7 3.167 4.21 1.407",
    fill: "#FFF",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.137 64.978v3.393H22.471c-.98 0-1.142-1.012-.263-1.633l7.473-2.968s.948 2.465 4.456 1.208",
    fill: "#6176F4",
    mask: "url(#wu0vevpulb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.137 64.852v4.751H22.471c-.98 0-1.142-1.77-.263-2.64l7.72-3.518s.7 3.167 4.21 1.407zM29.927 63.445l1.885-1.803M50.671 65.073l-1.937-2.756M55.057 64.852l-1.589-4.778",
    stroke: "#000",
    strokeWidth: 0.789,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#wu0vevpulb)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillSpreadsheet);
export default __webpack_public_path__ + "static/media/fill-spreadsheet.3c7329476ec1a984a844afc1e50ca3a2.svg";
export { ForwardRef as ReactComponent };